import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'
import { FullAuthUser, InviteObject } from '@dashboard/lib/types'
import { useAppStateSelector } from '@dashboard/hooks/useAppStateSelector'
import { useOnSuccess } from '@dashboard/hooks/useOnSuccess'
import { useAppDispatch } from '@dashboard/hooks/useAppDispatch'
import { loadMe } from '@dashboard/store/actions/user/me'
import Modal from '@dashboard/components/Modal'
import * as ls from 'local-storage'
import { ParsedUrlQuery } from 'querystring'
import { getQueryParam } from '@dashboard/lib/browser'
import { AUTH_QUERY_PARAMS_STORAGE_KEY } from '@dashboard/components/Registration/component'
import LinkInviteFlow from './components/LinkInviteFlow'
import EmailInviteFlow from './components/EmailInviteFlow'

interface OwnProps {
  authUser: FullAuthUser
  modalOpen: boolean
  toggleModal: () => void
}

const classNames = classNamesBind.bind(css)

const OrganizationInviteManagerModal: FC<OwnProps> = ({
  authUser,
  modalOpen,
  toggleModal,
}: OwnProps) => {
  const { inviteTasksState } = useAppStateSelector(state => state.profile)
  const dispatch = useAppDispatch()
  const authQueryParams =
    ls.get<ParsedUrlQuery | null>(AUTH_QUERY_PARAMS_STORAGE_KEY) || {}

  // Effects
  useOnSuccess([inviteTasksState], () => {
    dispatch(loadMe())
  })

  // Partials
  const renderInviteLinkFlow = (teamId: string) => {
    return (
      <LinkInviteFlow
        teamId={teamId}
        authQueryParams={authQueryParams}
        toggleModal={toggleModal}
      />
    )
  }

  const renderEmptyState = () => {
    return <div className={classNames('noInvites')}>No invites found</div>
  }

  const renderContent = () => {
    const emailInvite = authUser.team_invites[0] as InviteObject | null
    const teamId = getQueryParam(authQueryParams.team_id)

    if (teamId) return renderInviteLinkFlow(teamId)
    else if (emailInvite)
      return <EmailInviteFlow invite={emailInvite} toggleModal={toggleModal} />

    return renderEmptyState()
  }

  return (
    <Modal
      modalOpen={modalOpen}
      toggleModal={() => null}
      width="600"
      noPadding
      noCloseButton
    >
      <div className={classNames('title')}>New Invitation</div>
      {renderContent()}
    </Modal>
  )
}

export default OrganizationInviteManagerModal
